import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { connect } from 'react-redux';
import { resetSensorErrorCounts } from '../../stores/actions/installerActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardIcon from '../../../components/Card/CardIcon.js';
import Loading from '../../components/Loading/Loading';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React, { useState } from 'react';
import SettingsBackupRestore from '@material-ui/icons/SettingsBackupRestore';

interface IResetSensorErrorCountsSystemCardProps {
    hideAlert: () => void;
    systemID: number;
    resetSensorErrorCounts: (systemId: number | null) => Promise<number | null>;
}

// opened from the system card, like the service mode card (wisene only - the backend checks it too);
// the result is shown in a snackbar on the dashboard, on success the window closes
const ResetSensorErrorCountsSystemCard = ({ hideAlert, systemID, resetSensorErrorCounts }: IResetSensorErrorCountsSystemCardProps) => {
    const [resetting, setResetting] = useState(false);

    const onReset = () => {
        setResetting(true);
        resetSensorErrorCounts(systemID).then((count) => {
            setResetting(false);
            if (count !== null) {
                hideAlert();
            }
        });
    };

    const buttons = () => {
        if (resetting) {
            return (
                <div style={{ width: '100%', marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
                    <Loading transform={1} height={17} width={40} color='darkGray' />
                </div>
            );
        }
        return (
            <>
                <Button color='danger' onClick={onReset} className='downloadButton'>Reset</Button>
                <Button onClick={hideAlert} className='downloadButton'>Cancel</Button>
            </>
        );
    };

    return (
        <ErrorComponent Children message='Error'>
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <SettingsBackupRestore />
                    </CardIcon>
                    <h3 style={{ ...cardTitle, textAlign: 'left' }}>Sensor error counters</h3>
                </CardHeader>
                <CardBody>
                    <GridContainer style={{ margin: '0 0 0 -15px' }}>
                        <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                            <p>The sensor error counters of all devices of this system will be set to 0 and will start counting again from now.</p>
                        </GridItem>
                        <GridItem xs={12} style={{ margin: '25px 0 0 0', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            {buttons()}
                        </GridItem>
                    </GridContainer>
                </CardBody>
            </Card>
        </ErrorComponent>
    );
};

export default connect(null, { resetSensorErrorCounts })(ResetSensorErrorCountsSystemCard);
